import DialogComponent from "components/Dialog";

export default class InvoiceDetailDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            info: false
        };

        this.state = {
            ...this.defaultState
        };
    }

    show(info, modePage) {
        this.state.info = info;
        this.dialogTitle = "Информация о назначенном визите";
        this.state.modePage = modePage;
        super.show();
    }

    /*getFutureVisit(visitsOfClient) {
        let doctor = null;
        let date = null;

        visitsOfClient.forEach(it => {
            const { doctorId, beginDate, status } = it;
            if (new Date(beginDate) > new Date() && status === "WI_CREATED") {
                doctor = doctorId;
                date = beginDate;
            }
        });
        return { doctor, date };
    }*/

    getlastVisit(visitsOfClient) {
        let doctor = null;
        let date = null;

        for (let it of visitsOfClient) {
            const { beginDate, status, doctorId } = it;
            if (new Date(beginDate) < new Date() && status === "WI_COMPLETED") {
                doctor = doctorId;
                date = beginDate;
                break;
            }
        }
        return { doctor, date };
    }

    async onShow() {
        const resp = await this._request.visits.getForClient(this.state.info.client.id, "-endDate", false, ["WI_CREATED", "WI_COMPLETED"]);
        const visits = (resp?.data || []);
        const lastVisit = this.getlastVisit(visits);
        //const futureVisit = this.getFutureVisit(visits);
        const futureVisit = this._helper.getFutureVisit(visits);
        this.setState({ lastVisit, futureVisit });
    }

    insertDetailRow(text, value) {
        return (
            <div className="detailRow flex centerV gap8 text p1">
                <div className="rowText">{this.tr(text)}</div>
                <div className="flex1">{value || ""}</div>
            </div>
        );
    }

    renderButtons() {
        return <></>;
    }

    renderInfo(info) {
        const { client, doctorId, status, targetDate, createdTime,
            visitReason, visitRule, comment: commAdmin } = info;
        const { lastVisit, futureVisit } = this.state;
        const { title } = visitReason;
        const { comment } = visitRule;
        const doctor = globalThis.appPageView.getDoctorById(doctorId);

        const { statusRepVisit } = this._config;

        let lastV = "";
        if (lastVisit?.date) {
            const doctorInfo = globalThis.appPageView.getDoctorById(lastVisit.doctor);
            lastV = `${this._helper.date.toStr(lastVisit.date, "DD MMMM YYYY")} ${this._helper.string.formatFullName(doctorInfo, "short")}`;
        }

        let futureV = "";
        if (futureVisit?.date) {
            const doctorInfo = globalThis.appPageView.getDoctorById(futureVisit.doctor);
            futureV = `${this._helper.date.toStr(futureVisit.date, "DD MMMM YYYY")} ${this._helper.string.formatFullName(doctorInfo, "short")}`;
        }

        return (<div className="flex1 flex col gap8">
            {this.insertDetailRow("ФИО Пациента", this._helper.string.formatFullName(client))}
            {this.insertDetailRow("Врач", this._helper.string.formatFullName(doctor, "short"))}
            {this.insertDetailRow("Статус", this.tr(statusRepVisit[status]))}
            {this.insertDetailRow("Планируемая дата приема", this._helper.date.toStr(targetDate, "DD MMMM YYYY"))}
            {this.insertDetailRow("Причина", title)}
            {this.insertDetailRow("Дата назначения", this._helper.date.toStr(createdTime, "DD MMMM YYYY"))}
            {this.insertDetailRow("Описание к визиту", comment)}
            {this.insertDetailRow("Комментарий", commAdmin)}
            {this.insertDetailRow("Последний визит", lastV)}
            {this.insertDetailRow("Будущий визит", futureV)}
        </div>);
    }

    renderInfo2(info) {
        const { client, doctorId, createdTime } = info;
        const doctor = globalThis.appPageView.getDoctorById(doctorId);
        const { lastVisit, futureVisit } = this.state;

        let lastV = "";
        if (lastVisit?.date) {
            const doctorInfo = globalThis.appPageView.getDoctorById(lastVisit.doctor);
            lastV = `${this._helper.date.toStr(lastVisit.date, "DD MMMM YYYY")} ${this._helper.string.formatFullName(doctorInfo, "short")}`;
        }

        let futureV = "";
        if (futureVisit?.date) {
            const doctorInfo = globalThis.appPageView.getDoctorById(futureVisit.doctor);
            futureV = `${this._helper.date.toStr(futureVisit.date, "DD MMMM YYYY")} ${this._helper.string.formatFullName(doctorInfo, "short")}`;
        }

        return (<div className="flex1 flex col gap8">
            {this.insertDetailRow("ФИО Пациента", this._helper.string.formatFullName(client))}
            {this.insertDetailRow("Врач", this._helper.string.formatFullName(doctor, "short"))}
            {this.insertDetailRow("Дата назначения", this._helper.date.toStr(createdTime, "DD MMMM YYYY"))}
            {this.insertDetailRow("Последний визит", lastV)}
            {this.insertDetailRow("Будущий визит", futureV)}
        </div>);
    }

    renderContent() {
        const { info, modePage } = this.state;

        return (
            <div className="content flex col gap24">
                {modePage === "showRepVisits" ? this.renderInfo(info) : this.renderInfo2(info)}
            </div>
        );
    }
}
